module.exports = __webpack_public_path__ + "media/components/resort-webcams/static/icon--player-43678e9d9a57d9626457cb4f15092136.svg";